export enum UpdateStatus {
    NOT_SUBMITTED = 'NOT_SUBMITTED',
    SUBMIT_SUCCESS = 'SUBMIT_SUCCESS',
    SUBMIT_FAILURE = 'SUBMIT_FAILURE'
}
